import React from 'react';
import { MockCard, MockHeader, StaggerRow } from './shell';

const CONDITIONS = [
  { label: 'Air', value: '54\u00b0F', hint: 'Feels 49\u00b0' },
  { label: 'Water', value: '61\u00b0F', hint: 'Fairmount' },
  { label: 'Wind', value: '6 mph', hint: 'NW, cross' },
  { label: 'Flow', value: '2,140', hint: 'cfs, USGS' },
];

const SEATS = [
  ['C', 'M. Reyes'],
  ['8', 'J. Okafor'],
  ['7', 'T. Lindqvist'],
  ['6', 'D. Moreau'],
  ['5', 'A. Bianchi'],
  ['4', 'L. Haugen'],
  ['3', 'P. Deshmukh'],
  ['2', 'N. Abara'],
  ['B', 'S. Whitlock'],
];

export default function WorkoutMockup() {
  return (
    <MockCard>
      <MockHeader
        title={'Tuesday, Sep 8 \u00b7 Varsity'}
        subtitle={'Morning session \u00b7 5:45 AM'}
        live
      />

      {/* Live conditions pulled from the club's weather location + USGS gauge */}
      <div className="grid grid-cols-4 gap-px bg-slate-100">
        {CONDITIONS.map((c, i) => (
          <StaggerRow key={c.label} index={i} className="bg-white px-2.5 py-2.5 text-center">
            <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">
              {c.label}
            </p>
            <p className="mt-0.5 text-sm font-bold text-slate-900">{c.value}</p>
            <p className="text-[10px] text-slate-400">{c.hint}</p>
          </StaggerRow>
        ))}
      </div>

      <div className="px-4 py-4">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h4 className="text-base font-bold text-slate-900">Steady state &mdash; 3 &times; 20&prime;</h4>
            <p className="mt-0.5 text-xs text-slate-500">
              Rate 20&ndash;22 &middot; 4&prime; paddle between pieces
            </p>
          </div>
          <span className="shrink-0 rounded-md bg-blue-50 px-2 py-1 text-[11px] font-semibold text-blue-700 ring-1 ring-inset ring-blue-100">
            70% of 2k
          </span>
        </div>

        <div className="mt-3 flex items-center gap-2 rounded-lg bg-slate-50 px-3 py-2 ring-1 ring-inset ring-slate-100">
          <span className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">
            Target
          </span>
          <span className="font-mono text-sm font-bold text-slate-900">2:05.4</span>
          <span className="text-xs text-slate-500">/500m &middot; from your goal 2k</span>
        </div>

        <div className="mt-4">
          <div className="mb-2 flex items-center justify-between">
            <p className="text-xs font-semibold text-slate-900">
              Men&rsquo;s 1V &middot; Resolute 8+ &ldquo;Bergman&rdquo;
            </p>
            <span className="rounded bg-emerald-50 px-1.5 py-0.5 text-[10px] font-semibold text-emerald-700">
              Reserved
            </span>
          </div>

          {/* column flow so seats read stern-to-bow down the left, then the right */}
          <div className="grid grid-flow-col grid-rows-5 gap-x-3 gap-y-1">
            {SEATS.map(([seat, name], i) => (
              <StaggerRow
                key={seat}
                index={i}
                className="flex items-center gap-2 rounded-md bg-slate-50/70 px-1.5 py-1"
              >
                <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-slate-900 text-[10px] font-bold text-white">
                  {seat}
                </span>
                <span className="truncate text-xs text-slate-700">{name}</span>
              </StaggerRow>
            ))}
          </div>
        </div>

        <div className="mt-4 flex items-center justify-between border-t border-slate-100 pt-3 text-[11px] text-slate-500">
          <span>Blades: Croker S39 &middot; Set B</span>
          <span>5:45 &ndash; 7:15 AM</span>
        </div>
      </div>
    </MockCard>
  );
}
